import { createFileRoute } from '@tanstack/react-router';

import { SignupFormsListView } from '@/components/signup-forms/SignupFormsListView';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/signup-forms/')({
  component: SignupFormsListView,
});
